import { useEffect, useState } from "react";

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
}

/** Surfaces a small "Install app" button when the browser indicates the PWA
 *  is installable. On browsers that never fire beforeinstallprompt (Safari,
 *  Firefox) this component renders nothing — the AppLayout shows a Safari
 *  instruction banner separately. */
export function InstallPrompt(): JSX.Element | null {
  const [event, setEvent] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const handler = (e: Event): void => {
      e.preventDefault();
      setEvent(e as BeforeInstallPromptEvent);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (event === null) return null;

  return (
    <button
      type="button"
      className="vmc-tbtn"
      data-tour="header.install"
      onClick={async () => {
        await event.prompt();
        setEvent(null);
      }}
    >
      Install app
    </button>
  );
}
